export const environment = {
  production: false,
  apiPrefix: '/apis/api-gestao-termos-dev',
  baseUrl: 'https://homologacao.vivest.com.br',
  secret: '9ABD1328679B76D1E0781A231CFD8F69BF3C6A96119B3F2F0116636FE8B35C9E',
  ocpapimsubscriptionkey: 'aa7eca0e0c9b45e6ad854e24639cfea5',
  ambiente: 'desenvolvimento',
  // Sem portal para entregar o Token pela URL, a tela não abriria neste ambiente.
  allowDevAuthBypass: false,
};
